import { render } from "./Table.vue?vue&type=template&id=188dcb44"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=188dcb44&lang=scss"
script.render = render

export default script